import { MUTATION_TYPES } from './types';
import { initialState } from './state'; //Import initial state object for reset when was destroy

export const mutations = {
  [MUTATION_TYPES.RESET](state) {
    Object.assign(state, initialState());
  },

  [MUTATION_TYPES.SET_ACADEMIC_YEARS](state, academicYears) {
    state.filters.academicYears = academicYears;
    //OnChange
    state.filters.regions = [];
    state.filters.districts = [];
    state.filters.schools = [];
  },
  [MUTATION_TYPES.SET_REGIONS](state, regions) {
    state.filters.regions = regions;
    const defaultRegion = regions.find((r) => r.selected);
    if (!defaultRegion) {
      //Only is collection
      state.filters.districts = [];
      state.filters.schools = [];
    }
  },
  [MUTATION_TYPES.SET_DISTRICTS](state, districts) {
    state.filters.districts = districts;
    state.filters.schools = [];
  },
  [MUTATION_TYPES.SET_SCHOOLS](state, schools) {
    state.filters.schools = schools;
  },
  [MUTATION_TYPES.SET_CURRENT_FILTERS](state, currentFilter) {
    state.model = currentFilter;
  },
  [MUTATION_TYPES.SET_INTERVIEWS](state, results) {
    state.results = results.data;
    state.paging = {
      count: results.count,
      currentPage: results.currentPage,
      pageCount: results.pageCount,
      totalItemCount: results.totalItemCount,
    };
  },
};
